import { Component, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-calendar-icon',
	templateUrl: './calendar-icon.component.html',
})
export class CalendarIconComponent {
	@Input() public readonly variableName?: string = 'brandPrimary';

	constructor() {}
}
